import React from 'react';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import ImageCard from '../../Components/ImageCard/ImageCard';
import imgLocal from '../../assets/news-events/Local.png';
import imgMeasurement from '../../assets/news-events/Measurement.png';
import imgLessHeadache from '../../assets/news-events/LessHeadache.png';
import { Container, Row, Col, Button } from 'react-bootstrap';
import CenterStage from '../../Components/CenterStage/CenterStage';
import imgMainbldg from '../../assets/news-events/Mainbldg.jpg';

function NewsEventsPage() {
  return (
    <div>

              <CenterStage
                    imageSrc={imgMainbldg}
                    title={"We are HANSA‑FLEX "}
                    paragraph={"HANSA-FLEX is a family-owned company (AG) with global operations and headquarters in Bremen. We are one of the world's leading suppliers of products, services, and holistic solutions for hydraulics. With more than 4,200 employees at over 445 locations, we strive to be the best partner and service provider for our customers every day."}
                />

         <SectionHeader
          title="News and Events" />
        <Container className="custom-container">
          <Row>
            <Col sm={12} md={4} lg={4} data-aos="fade-up"><ImageCard image={imgLocal} learnMoreLink={'/Local'} title="Local or imported stock? What weighs most in the operation?" /></Col>
            <Col sm={12} md={4} lg={4} data-aos="fade-up"><ImageCard image={imgMeasurement} learnMoreLink={'/Measurement'} title="Essential Tools for Hydraulic Measurement" desc="" /></Col>
            <Col sm={12} md={4} lg={4} data-aos="fade-up"><ImageCard image={imgLessHeadache} learnMoreLink={'/LessHeadache'} title="Less Headache with Maintenance Plans" desc="" /></Col>
           

          </Row>
        </Container>
    </div>
  );
}

export default NewsEventsPage;